// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Audit from "@material-ui/icons/TrackChanges";
import Landing from "@material-ui/icons/FlightLandOutlined";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import NotFound from "views/NotFound/Index.jsx";

import AirlinePaymentPage from "Regional-Views/AirlinePayment/Index.jsx";
import ExchangeRate from "Regional-Views/ExchangeRate/Index.jsx";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

const routes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-regional/exchangeRate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    component: ExchangeRate,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/regional-accounts.jsx